(() => {
  const mounted = new Map();
  function initialize(root = document) {
    const elements = selector => [...root.querySelectorAll(selector)];
    elements('.accordion-item').forEach((item, index) => {
      const header = item.querySelector('.accordion-header');
      if (!header || mounted.has(item)) return;
      const controller = new AbortController();
      if (index === 0) item.classList.add('active');
      header.addEventListener('click', event => {
        event.preventDefault();
        const active = item.classList.contains('active');
        item.parentElement.querySelectorAll('.accordion-item').forEach(sibling => sibling.classList.remove('active'));
        if (!active) item.classList.add('active');
      }, { signal: controller.signal });
      mounted.set(item, () => controller.abort());
    });
    elements('.accordion__header').forEach(header => {
      if (mounted.has(header)) return;
      const body = header.nextElementSibling;
      if (!body?.matches('.accordion__body')) return;
      const controller = new AbortController();
      header.setAttribute('role','button');
      header.tabIndex = 0;
      const toggle = () => {
        const active = header.classList.contains('is-active');
        header.parentElement.querySelectorAll('.accordion__header, .accordion__body').forEach(element => {
          element.classList.remove('is-active');
          if(element.matches('.accordion__header')) element.setAttribute('aria-expanded','false');
        });
        if(!active) { header.classList.add('is-active'); body.classList.add('is-active'); }
        header.setAttribute('aria-expanded',String(!active));
      };
      header.setAttribute('aria-expanded',String(header.classList.contains('is-active')));
      header.addEventListener('click',toggle,{signal:controller.signal});
      header.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();toggle();}},{signal:controller.signal});
      mounted.set(header,()=>controller.abort());
    });
    elements('.add-to-cart-form').forEach(form => {
      if (mounted.has(form)) return;
      const controller = new AbortController();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if(form.dataset.ppsSubmitting === 'true') return;
        form.dataset.ppsSubmitting = 'true';
        const button = form.querySelector('[type="submit"]');
        const wasDisabled = button?.disabled;
        if(button) button.disabled = true;
        let error = form.querySelector('[data-pps-cart-error]');
        if(error) error.remove();
        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add', { method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:new URLSearchParams(new FormData(form)),signal:controller.signal });
          if(!response.ok) throw new Error(window.cartStrings?.error || response.statusText);
          const cartPath = window.routes?.cart_url || '/cart';
          window.location.assign(cartPath.replace(/\/cart\/?$/, '/checkout'));
        } catch(exception) {
          if(exception.name === 'AbortError') return;
          error = document.createElement('p');
          error.dataset.ppsCartError = '';
          error.setAttribute('role','alert');
          error.textContent = window.cartStrings?.error || exception.message;
          form.append(error);
        } finally {
          delete form.dataset.ppsSubmitting;
          if(button) button.disabled = wasDisabled;
        }
      }, {signal:controller.signal});
      mounted.set(form,()=>controller.abort());
    });
    if(typeof window.Swiper === 'function') elements('.swiper-container').forEach(container => {
      if(container.swiper || mounted.has(container)) return;
      const slider = new window.Swiper(container, { speed:500,direction:'vertical',mousewheel:{releaseOnEdges:true},pagination:{el:container.querySelector('.swiper-pagination'),clickable:true},watchOverflow:true,touchReleaseOnEdges:true });
      mounted.set(container,()=>slider.destroy(true,true));
    });
    const jquery = window.jQuery;
    if(jquery?.fn?.slick) {
      for(const [selector,options] of [
        ['.masanaryimagesslide',{slidesToShow:1,slidesToScroll:1,centerMode:true,centerPadding:'40px',adaptiveHeight:true,arrows:true,dots:false}],
        ['#homereviewmobileshow',{slidesToShow:1,slidesToScroll:1,centerMode:false,adaptiveHeight:true,arrows:true,dots:false}]
      ]) elements(selector).forEach(element=>{
        if(element.classList.contains('slick-initialized') || mounted.has(element)) return;
        jquery(element).slick(options);
        mounted.set(element,()=>{if(element.classList.contains('slick-initialized'))jquery(element).slick('unslick');});
      });
    }
    const hours = root.querySelector('#hours');
    const minutes = root.querySelector('#minutes');
    const seconds = root.querySelector('#seconds');
    if(hours && minutes && seconds && !mounted.has(hours)) {
      const end = Date.now() + 15154 * 1000;
      const update = () => {const remaining=Math.max(0,Math.ceil((end-Date.now())/1000));hours.textContent=String(Math.floor(remaining/3600)).padStart(2,'0');minutes.textContent=String(Math.floor(remaining%3600/60)).padStart(2,'0');seconds.textContent=String(remaining%60).padStart(2,'0');if(!remaining)clearInterval(timer);};
      const timer = setInterval(update,1000);
      update();
      mounted.set(hours,()=>clearInterval(timer));
    }
    if(/\/account\/login\/?$/.test(window.location.pathname)) document.body.classList.add('custom-login-page');
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',event=>{for(const [element,cleanup] of mounted){if(event.target.contains(element)){cleanup();mounted.delete(element);}}});
})();
